import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getProjectsTags() {
      return getState().tags;
    },
    isRetrieveProjectsTagsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveProjectsTagsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveProjectsTagsRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
